//
// Action types
//

export const INCREMENT_RESOURCES_LIST_VERSION = "INCREMENT_RESOURCES_LIST_VERSION";

//
// Action creators
//

export function incrementResourcesListVersion(resourcesListKey) {
  return {
    type: INCREMENT_RESOURCES_LIST_VERSION,
    resourcesListKey
  };
}

function incrementResourcesListVersionHandler(state) {
  return ++state;
}

//
// Reducer and handlers
//

export function reduceVersion(state, action) {
  switch (action && action.type) {
    case INCREMENT_RESOURCES_LIST_VERSION:
      return incrementResourcesListVersionHandler(state);

    default:
      return state || 0;
  }
}
